import { RoomStatusProps } from "../../../../interfaces/RoomStatusProps.interface"
import RoomCardHeader from "../../shared/RoomCardHeader/RoomCardHeader"
import Wrapper from "../../shared/Wrapper/Wrapper"
import { useVentaEnLineaCountdown } from "../../../../hooks/useVentaEnLineaCountdown"

import "./VentaEnLinea.css"

const VentaEnLinea = (props: RoomStatusProps) => {
    const { timeLeft, isExceeded } = useVentaEnLineaCountdown(
        props.occupiedTimeStart,
        props.occupiedTimeEndCondensada
    )

    return (
        <Wrapper>
            <RoomCardHeader
                hasIncidences={props.hasIncidences}
                iconName={"DoorOpenNew"}
                roomNumber={props.roomNumber}
                roomTypeName={props.roomTypeName}
                timeout={props.timeout}
                iconBgColor="var(--purple-drawer-primario)"
            />
            <div className="room-card--lg--venta-en-linea__body">
                {isExceeded ? (
                    <>
                        <span className="room-card--lg--venta-en-linea__label">Venta en línea</span>
                        <span className="room-card--lg--venta-en-linea__no-show">No show</span>
                    </>
                ) : (
                    <>
                        <span className="room-card--lg--venta-en-linea__timer">{timeLeft}</span>
                        <span className="room-card--lg--venta-en-linea__codigo">
                            Código: {props.ventaEnLineaCodigo || "-"}
                        </span>
                    </>
                )}
            </div>
        </Wrapper>
    )
}

export default VentaEnLinea
